import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0568f82a&"
var script = {}
import style0 from "@/assets/css/element-m.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/css/app.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports